/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { KiteTrxMoreDetailInfo } from './KiteTrxMoreDetailInfo';

export type KiteTrxDetailInfo = {
    TRXA: string;
    TRXTP: KiteTrxDetailInfo.TRXTP;
    CBB: string;
    STAT: KiteTrxDetailInfo.STAT;
    BNO: string;
    AG: string;
    FROMADDRSINFO: EvmAddressSummaryInfo;
    TOADDRSINFO: EvmAddressSummaryInfo;
    AMT: string;
    VAL: string;
    TRXF: string;
    TRXFVAL: string;
    GP: string;
    GPG: string;
    GL: string;
    GU: string;
    GUP: string;
    UT: number;
    TRXID: string;
    SNO: string;
    MTHID: string;
    MTHNM: string;
    MD: KiteTrxMoreDetailInfo;
};

export namespace KiteTrxDetailInfo {

    export enum TRXTP {
        NORMAL = 'NORMAL',
        INTERNAL = 'INTERNAL',
        PENDING = 'PENDING',
    }

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

